// Core
import React, { useState, useEffect } from "react";

// Components - Contrib Libraries
import { Accordion, Card } from "react-bootstrap";

// Components - Custom
import { fetchFeaturedQuestions } from "../data/apis";
import loader from "../assets/loading.gif";

function FeaturedQuestion(props) {
   const { subjectArea_ID } = props;
   const [featuredFAQs, setFeaturedFAQs] = useState();

   useEffect(() => {
      (async () => {
         var data = await fetchFeaturedQuestions(subjectArea_ID);
         setFeaturedFAQs(data);
      })();
   }, [subjectArea_ID]);

   if (!featuredFAQs) {
      return (
         <div className="loader">
            <img src={loader} alt="loader" />
         </div>
      );
   }

   if (featuredFAQs.length > 0) {
      return (
         <Card className="shadow my-4">
            <Card.Header>Featured Questions</Card.Header>
            <Card.Body>
               <Accordion flush>
                  {featuredFAQs.map((item, i) => (
                     <Accordion.Item key={i} eventKey={i}>
                        <Accordion.Header>{item.Question}</Accordion.Header>
                        <Accordion.Body>
                           <p dangerouslySetInnerHTML={{ __html: item.Answer }}></p>
                        </Accordion.Body>
                     </Accordion.Item>
                  ))}
               </Accordion>
            </Card.Body>
         </Card>
      );
   }
   return null;
}

export default FeaturedQuestion;
